import FaceIcon from '../../assets/icons/FaceIcon';
import SecurityIcon from '../../assets/icons/SecurityIcon';
import WarningIcon from '../../assets/icons/WarningIcon';
import Button from '../../components/button';
import { PageContent } from '../../components/modal/styles';
import { useConnectWithWallet } from '../../hooks/useConnectWithWallet';
import useLocales from '../../hooks/useLocales';
import { useWalletProps } from '../../hooks/useWalletsProps';
import {
  StyleContainer,
  StyleDescription,
  StyleFeatureContent,
  StyleFeatureDescription,
  StyleFeatureItem,
  StyleFeatureList,
  StyleFeatureTitle,
  StyleWarning,
  StyleWarningText,
} from './styles';

const Signup = () => {
  const locales = useLocales();
  const connectWallet = useConnectWithWallet();
  const wallet = useWalletProps('passkeySmartWallet');

  return (
    <PageContent>
      <StyleContainer>
        <StyleDescription>{locales.passkeyStorageInfo}</StyleDescription>
        <StyleFeatureList>
          <StyleFeatureItem>
            <FaceIcon />
            <StyleFeatureContent>
              <StyleFeatureTitle>{locales.convenientAndFast}</StyleFeatureTitle>
              <StyleFeatureDescription>{locales.biometricTransactionInfo}</StyleFeatureDescription>
            </StyleFeatureContent>
          </StyleFeatureItem>
          <StyleFeatureItem>
            <SecurityIcon />
            <StyleFeatureContent>
              <StyleFeatureTitle>{locales.increasedSecurity}</StyleFeatureTitle>
              <StyleFeatureDescription>{locales.passkeySecurityInfo}</StyleFeatureDescription>
            </StyleFeatureContent>
          </StyleFeatureItem>
        </StyleFeatureList>
        <StyleWarning>
          <WarningIcon />
          <StyleWarningText>{locales.passkeyDeletionWarning}</StyleWarningText>
        </StyleWarning>
        <Button
          onClick={() => {
            connectWallet(wallet!, {
              passkeyParams: {
                isRegistering: true,
              },
            });
          }}
        >
          {locales.setupPasskey}
        </Button>
      </StyleContainer>
    </PageContent>
  );
};

export default Signup;
